import { render, staticRenderFns } from "./settingPrintNomal.vue?vue&type=template&id=62396c89&scoped=true"
import script from "./settingPrintNomal.vue?vue&type=script&lang=js"
export * from "./settingPrintNomal.vue?vue&type=script&lang=js"
import style0 from "./settingPrintNomal.vue?vue&type=style&index=0&id=62396c89&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62396c89",
  null
  
)

export default component.exports